import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
const Export = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="eqpexport_sec">
        <div className="qep_grad">
          <h2>Export QEP Plan</h2>
          <button type="button">
            <svg
              className="me-3"
              width="15"
              height="14"
              viewBox="0 0 15 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 11.875V9.375C15 9.20924 14.9342 9.05027 14.8169 8.93306C14.6997 8.81585 14.5408 8.75 14.375 8.75C14.2092 8.75 14.0503 8.81585 13.9331 8.93306C13.8158 9.05027 13.75 9.20924 13.75 9.375V11.875C13.75 12.0408 13.6842 12.1997 13.5669 12.3169C13.4497 12.4342 13.2908 12.5 13.125 12.5H1.875C1.70924 12.5 1.55027 12.4342 1.43306 12.3169C1.31585 12.1997 1.25 12.0408 1.25 11.875V9.375C1.25 9.20924 1.18415 9.05027 1.06694 8.93306C0.949731 8.81585 0.79076 8.75 0.625 8.75C0.45924 8.75 0.300269 8.81585 0.183058 8.93306C0.0658481 9.05027 0 9.20924 0 9.375V11.875C0 12.3723 0.197544 12.8492 0.549175 13.2008C0.900806 13.5525 1.37772 13.75 1.875 13.75H13.125C13.6223 13.75 14.0992 13.5525 14.4508 13.2008C14.8025 12.8492 15 12.3723 15 11.875ZM11.0125 8.6125L7.8875 11.1125C7.77716 11.1997 7.64063 11.2471 7.5 11.2471C7.35937 11.2471 7.22284 11.1997 7.1125 11.1125L3.9875 8.6125C3.87364 8.50502 3.80426 8.35872 3.7931 8.20253C3.78195 8.04635 3.82982 7.89167 3.92725 7.7691C4.02468 7.64652 4.16457 7.56498 4.31924 7.54062C4.47392 7.51625 4.6321 7.55082 4.7625 7.6375L6.875 9.325V0.625C6.875 0.45924 6.94085 0.300269 7.05806 0.183058C7.17527 0.0658481 7.33424 0 7.5 0C7.66576 0 7.82473 0.0658481 7.94194 0.183058C8.05915 0.300269 8.125 0.45924 8.125 0.625V9.325L10.2375 7.6375C10.3004 7.57809 10.375 7.5324 10.4565 7.50333C10.5381 7.47425 10.6247 7.46242 10.711 7.46859C10.7974 7.47476 10.8815 7.49878 10.958 7.53915C11.0346 7.57952 11.1019 7.63535 11.1558 7.7031C11.2096 7.77085 11.2488 7.84905 11.2709 7.93273C11.2929 8.01642 11.2974 8.10378 11.2839 8.18927C11.2704 8.27476 11.2394 8.35653 11.1926 8.42938C11.1459 8.50223 11.0846 8.56459 11.0125 8.6125Z"
                fill="#212121"
              />
            </svg>
            Export{" "}
          </button>
        </div>
        <div className="row">
          <div className="col-md-6 col-lg-4">
            <div className="common_card mb-3 mb-lg-0">
              <h4 className="exportpd_head">6/2/2025, 11:23:31 AM </h4>
              <ul className="pdf_goal">
                <li>
                  <div>
                    <span>Goals:</span> 1
                  </div>
                  <div>
                    <span>Status:</span> In Progress
                  </div>
                </li>
                <li>
                  <button
                    type="button"
                    className="btn-sm btn btn-primary"
                    onClick={handleShow}
                  >
                    View Full Record
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="common_card mb-3 mb-lg-0">
              <h4 className="exportpd_head">6/2/2025, 11:23:31 AM </h4>
              <ul className="pdf_goal">
                <li>
                  <div>
                    <span>Goals:</span> 1
                  </div>
                  <div>
                    <span>Status:</span> In Progress
                  </div>
                </li>
                <li>
                  <button type="button" className="btn-sm btn btn-primary">
                    View Full Record
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="common_card">
              <h4 className="exportpd_head">6/2/2025, 11:23:31 AM </h4>
              <ul className="pdf_goal">
                <li>
                  <div>
                    <span>Goals:</span> 1
                  </div>
                  <div>
                    <span>Status:</span> In Progress
                  </div>
                </li>
                <li>
                  <button type="button" className="btn-sm btn btn-primary">
                    View Full Record
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        className="custom_popup"
        dialogClassName="modal-dialog-centered"
      >
        <Modal.Header closeButton>
          <Modal.Title>QEP Record – 6/2/2025, 11:23:31 AM</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="eqp_export_cont">
            <div className="stats mb-3">
              <h3>Mission</h3>
              <p>
                Empower individuals with disabilities through quality,
                person-centered coordination.
              </p>
            </div>
            <div className="stats mb-3">
              <h3>Vision</h3>
              <p>
                To create a community where all individuals have access to
                meaningful support and opportunities.
              </p>
            </div>
            <div className="stats ">
              <h3>Values</h3>
              <p>Dignity, Equity, Transparency, Compassion</p>
            </div>
            <div className="qep_grad">
              <h2>Goals</h2>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="stats mb-3">
                  <h3>Type</h3>
                  <p>Training Compliance</p>
                </div>
              </div>
              <div className="col-6">
                <div className="stats mb-3">
                  <h3>Goal</h3>
                  <p>Improve staff training compliance</p>
                </div>
              </div>
            </div>
            <div className="stats mb-3">
              <h3>Objective</h3>
              <p>
                Reduce overdue trainings from 20% to less than 5% by Dec 2025
              </p>
            </div>
            <div className="stats mb-3">
              <h3>Benchmarks</h3>
              <p>Q2: 15%, Q3: 10%, Q4: less than 5%</p>
            </div>
            <div className="stats mb-3">
              <h3>Actions</h3>
              <p>
                Implement LMS with alerts – IT/Training – Due July 1 |
                Supervisors track training weekly – Supervisors – Ongoing
              </p>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="stats mb-3">
                  <h3>Stabilization</h3>
                  <p>Embed training compliance check into annual review</p>
                </div>
              </div>
              <div className="col-6">
                <div className="stats mb-3">
                  <h3>Status</h3>
                  <p>In Progress</p>
                </div>
              </div>
            </div>
            <div className="stats ">
              <h3>Actions</h3>
              <p>
                Implement LMS with alerts – IT/Training – Due July 1 |
                Supervisors track training weekly – Supervisors – Ongoing
              </p>
            </div>
            <div className="qep_grad">
              <h2>Goal Updates</h2>
            </div>
            <div className="stats mb-3">
              <h3>Adjustments</h3>
              <p>
                System is monitoring unmet indicators for automatic
                reassignment.
              </p>
            </div>
            <div className="stats ">
              <h3>Decisions</h3>
              <p>-</p>
            </div>
            <div className="qep_grad">
              <h2>Approval Dates</h2>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="stats">
                  <h3>Start</h3>
                  <p>N/A</p>
                </div>
              </div>
              <div className="col-6">
                <div className="stats">
                  <h3>End</h3>
                  <p>N/A</p>
                </div>
              </div>
            </div>
            <div className="qep_grad">
              <h2>Survey Summaries</h2>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="stats mb-3">
                  <h3>Participant Survey</h3>
                  <p>Not provided</p>
                </div>
                <div className="stats">
                  <h3>Provider Survey</h3>
                  <p>Not provided</p>
                </div>
              </div>
              <div className="col-6">
                <div className="stats mb-3">
                  <h3>Employee Survey</h3>
                  <p>Not provided</p>
                </div>
                <div className="stats">
                  <h3>Stakeholder Survey</h3>
                  <p>Not provided</p>
                </div>
              </div>
            </div>
            <div className="qep_grad mb-2">
              <h2>Strengths, Needs & Priorities</h2>
            </div>
            <div className="stats ">
              <p>Not provided</p>
            </div>
            <div className="qep_grad mb-2">
              <h2>Implementation & Stabilization</h2>
            </div>
            <div className="stats ">
              <p>Not provided</p>
            </div>
            <div className="qep_grad mb-2">
              <h2>Review & Update Process</h2>
            </div>
            <div className="stats ">
              <p>Not provided</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Export;
